var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Gardeners',"subtitle":'Add new gardener'}}),_c('gardener-form',{attrs:{"action":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }